import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { PipeModule } from '../../common/pipes/pipe.module';
import { SuggestionsSectionModule } from '../../sections/suggestions-section/suggestions-section.module';
import { SvgCommonModule } from '../../shared/svg/svg-common.module';
import { UiModule } from '../../ui/ui.module';

import { ProductsCreatePageComponent } from './products-create-page.component';
import { ProductsShowcaseModule } from './products-showcase/products-showcase.module';

@NgModule({
	imports: [
		CommonModule,
		UiModule,
		SvgCommonModule,
		RouterModule,
		PipeModule,
		ProductsShowcaseModule,
		SuggestionsSectionModule,
	],
	declarations: [ProductsCreatePageComponent],
	exports: [ProductsCreatePageComponent],

})

export class ProductsCreatePageModule { }
